import { render, staticRenderFns } from "./ArticleCardSmall.vue?vue&type=template&id=6453c435&scoped=true"
import script from "./ArticleCardSmall.vue?vue&type=script&lang=js"
export * from "./ArticleCardSmall.vue?vue&type=script&lang=js"
import style0 from "./ArticleCardSmall.vue?vue&type=style&index=0&id=6453c435&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6453c435",
  null
  
)

export default component.exports